import { BASE_URL, AZURE_STORAGE_URL } from './envs';

export const AZURE_STORAGE = AZURE_STORAGE_URL;
export const API_ENDPOINT = BASE_URL + 'api/';
export const CONTENT_URL = AZURE_STORAGE + 'contents/';
export const IMAGE_URL = CONTENT_URL + 'Images/';
export const GENERAL_PATH = AZURE_STORAGE + 'general/';
